/**
 * Display a flash message on the page that matches the HAML version.
 * Inserts an alert after the #dynamic_flash element.
 *
 * @param {'success'|'info'|'warning'|'error'} type - The alert type
 * @param {string} message - The message to display
 */
export default function showFlash(type = 'warning', message = '') {
  const $target = $('#dynamic_flash');
  if (!$target.length) return;

  const iconMap = {
    success: 'icon-alert_success',
    info: 'icon-alert_info',
    warning: 'icon-alert_warning',
    error: 'icon-alert_error',
  };

  const icon = iconMap[type] || iconMap.warning;

  const html = `<div class="callout alert alert--${type}" role="alert" tabindex="0">`
      + '<div class="alert__body">'
        + `<div class="alert__icon"><i class="${icon}" aria-hidden="true"></i></div>`
        + `<div class="alert__content"><div class="alert__text">${message}</div></div>`
      + '</div>'
      + '<button class="button close-button button--close" type="button" data-close="true" aria-label="Dismiss">'
        + '<span aria-hidden="true" class="icon-general_close"></span>'
      + '</button>'
    + '</div>';
  $target.after(html);
}
